<template>
  <v-container fluid class="cuestionario-page pa-0">
    <v-toolbar class="mb-8" dense color="#FBFAF1" style="min-height: 80px">
      <v-spacer />
      <v-toolbar-title class="mt-6 text-center">
        <img src="../assets/logo7.svg" alt="Rutas Meigas" class="logo" />
      </v-toolbar-title>
      <v-spacer />
    </v-toolbar>

    <v-container class="pb-12 cuestionario-container">
      <v-row justify="center">
        <v-col cols="12">
          <div v-if="cargando" class="text-center py-16" aria-live="polite">
            <v-progress-circular indeterminate color="#FF9C00" size="56" width="5" />
            <p class="mt-5 mb-0 subtitle-1">{{ $t('mensajes.cuestionario.cargando') }}</p>
          </div>

          <v-alert v-else-if="errorCarga" type="error" outlined prominent>
            {{ errorCarga }}
          </v-alert>

          <template v-else-if="cuestionario">
            <v-alert v-if="!cuestionario.disponible" color="#191970" dark prominent>
              <div class="font-weight-bold mb-1">
                {{ $t('mensajes.cuestionario.no_disponible') }}
              </div>
              <div v-if="cuestionario.disponible_desde">
                {{ $t('mensajes.cuestionario.disponible_desde', { fecha: formatearFecha(cuestionario.disponible_desde) }) }}
              </div>
            </v-alert>

            <v-card v-else-if="cuestionario.completado || enviado" class="estado-card pa-6 text-center" flat>
              <v-icon color="success" size="68">mdi-check-circle-outline</v-icon>
              <h2 class="mt-4 mb-2">{{ $t('mensajes.cuestionario.gracias') }}</h2>
              <p class="mb-0 subtitle-1">{{ $t('mensajes.cuestionario.enviado_correctamente') }}</p>
            </v-card>

            <v-alert v-else-if="cuestionario.total_bloques === 0" type="info" outlined prominent>
              {{ $t('mensajes.cuestionario.sin_preguntas') }}
            </v-alert>

            <template v-else>
              <v-alert v-if="mensajeExito" type="success" outlined dismissible @input="mensajeExito = ''">
                {{ mensajeExito }}
              </v-alert>

              <v-alert v-if="errorEnvio" type="error" outlined dismissible @input="errorEnvio = ''">
                {{ errorEnvio }}
              </v-alert>

              <v-sheet class="seccion-panel seccion-rutas mb-4" color="#FBFAF1">
                <div class="rutas-header px-4 px-sm-6 pt-4 pb-2">
                  <div class="rutas-etiqueta d-flex align-center mb-1">
                    <v-icon color="#FF9C00" small class="mr-2">mdi-heart-outline</v-icon>
                    {{ $t('mensajes.cuestionario.secciones.rutas_meigas') }}
                  </div>
                  <h1 class="titulo-principal mb-1">{{ $t('mensajes.cuestionario.titulo') }}</h1>
                  <p class="introduccion mb-0">{{ $t('mensajes.cuestionario.introduccion') }}</p>
                </div>

                <v-row v-if="bloqueGeneral" justify="start" class="ma-0 px-1 px-sm-3 pb-3">
                  <v-col cols="12" md="10" lg="8" class="d-flex">
                    <cuestionario-bloque
                      :bloque="bloqueGeneral"
                      simple
                      @puntuar="actualizarPuntuacion"
                      @comentar="actualizarComentario"
                    />
                  </v-col>
                </v-row>
              </v-sheet>

              <v-expansion-panels v-model="panelesAbiertos" multiple accordion class="secciones-paneles">
                <v-expansion-panel v-if="bloquesAlojamientos.length" class="seccion-panel mb-4">
                  <v-expansion-panel-header class="seccion-header">
                    <div class="d-flex align-center">
                      <v-icon color="#FF9C00" class="mr-2">mdi-bed-outline</v-icon>
                      <span class="seccion-titulo">{{ $t('mensajes.cuestionario.secciones.alojamientos') }}</span>
                      <v-chip x-small class="ml-2">{{ bloquesAlojamientos.length }}</v-chip>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col
                        v-for="bloque in bloquesAlojamientos"
                        :key="`alojamiento-${bloque.target_id}`"
                        cols="12"
                        md="6"
                        lg="4"
                        class="d-flex"
                      >
                        <cuestionario-bloque
                          :bloque="bloque"
                          @puntuar="actualizarPuntuacion"
                          @comentar="actualizarComentario"
                        />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel v-if="bloquesServicios.length" class="seccion-panel mb-4">
                  <v-expansion-panel-header class="seccion-header">
                    <div class="d-flex align-center">
                      <v-icon color="#FF9C00" class="mr-2">mdi-compass-outline</v-icon>
                      <span class="seccion-titulo">{{ $t('mensajes.cuestionario.secciones.servicios') }}</span>
                      <v-chip x-small class="ml-2">{{ bloquesServicios.length }}</v-chip>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col
                        v-for="bloque in bloquesServicios"
                        :key="`servicio-${bloque.target_id}`"
                        cols="12"
                        md="6"
                        lg="4"
                        class="d-flex"
                      >
                        <cuestionario-bloque
                          :bloque="bloque"
                          @puntuar="actualizarPuntuacion"
                          @comentar="actualizarComentario"
                        />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

              <div class="text-center mt-8">
                <v-btn
                  x-large
                  rounded
                  depressed
                  color="#191970"
                  class="enviar-btn px-10"
                  :loading="enviando"
                  :disabled="enviando || !hayRespuestas"
                  @click="enviar"
                >
                  {{ $t('mensajes.cuestionario.enviar') }}
                  <v-icon right>mdi-send</v-icon>
                </v-btn>
                <p v-if="!hayRespuestas" class="caption mt-3 mb-0">
                  {{ $t('mensajes.cuestionario.responde_una') }}
                </p>
              </div>
            </template>
          </template>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import CuestionarioBloque from '@/components/cuestionario/CuestionarioBloque.vue';
import { enviarCuestionario, obtenerCuestionario } from '@/services/cuestionario';

export default {
  name: 'Cuestionario',

  components: {
    CuestionarioBloque,
  },

  data() {
    return {
      cargando: true,
      enviando: false,
      enviado: false,
      cuestionario: null,
      bloques: [],
      errorCarga: '',
      errorEnvio: '',
      mensajeExito: '',
      panelesAbiertos: [0, 1],
    };
  },

  computed: {
    bloqueGeneral() {
      return this.bloques.find(bloque => bloque.tipo === 'general') || null;
    },

    bloquesAlojamientos() {
      return this.bloques.filter(bloque => bloque.tipo === 'alojamiento');
    },

    bloquesServicios() {
      return this.bloques.filter(bloque => bloque.tipo === 'servicio');
    },

    hayRespuestas() {
      return this.bloques.some(bloque =>
        bloque.preguntas.some(pregunta => this.preguntaContestada(pregunta))
      );
    },
  },

  mounted() {
    this.cargar();
  },

  methods: {
    async cargar() {
      this.cargando = true;
      this.errorCarga = '';

      try {
        const cuestionario = await obtenerCuestionario(this.$route.params.hash);
        this.cuestionario = cuestionario;
        this.$i18n.locale = (cuestionario.idioma || 'ES').toLowerCase();
        this.bloques = (cuestionario.bloques || []).map(bloque => ({
          ...bloque,
          preguntas: bloque.preguntas.map(pregunta => ({
            ...pregunta,
            respuesta: {
              puntuacion: null,
              comentario: '',
            },
          })),
        }));
      } catch (error) {
        this.errorCarga = this.mensajeError(error, this.$t('mensajes.cuestionario.error_carga'));
      } finally {
        this.cargando = false;
      }
    },

    actualizarPuntuacion({ pregunta, puntuacion }) {
      pregunta.respuesta.puntuacion = puntuacion;
      if (puntuacion === null) {
        pregunta.respuesta.comentario = '';
      }
    },

    actualizarComentario({ pregunta, comentario }) {
      pregunta.respuesta.comentario = comentario;
    },

    preguntaContestada(pregunta) {
      return pregunta.respuesta.puntuacion !== null ||
        Boolean((pregunta.respuesta.comentario || '').trim());
    },

    construirValoraciones() {
      return this.bloques.reduce((valoraciones, bloque) => {
        const respuestas = bloque.preguntas
          .filter(pregunta => this.preguntaContestada(pregunta))
          .map(pregunta => ({
            valoracion_pregunta_id: pregunta.id,
            puntuacion: pregunta.respuesta.puntuacion,
            comentario: (pregunta.respuesta.comentario || '').trim() || null,
          }));

        if (respuestas.length) {
          valoraciones.push({
            tipo: bloque.tipo,
            target_id: bloque.target_id,
            respuestas,
          });
        }

        return valoraciones;
      }, []);
    },

    async enviar() {
      const valoraciones = this.construirValoraciones();
      if (!valoraciones.length) {
        this.errorEnvio = this.$t('mensajes.cuestionario.responde_una');
        return;
      }

      this.enviando = true;
      this.errorEnvio = '';

      try {
        await enviarCuestionario(this.$route.params.hash, valoraciones);
        const cantidadEnviada = valoraciones.length;
        await this.cargar();
        if (this.cuestionario.completado) {
          this.enviado = true;
        } else {
          this.mensajeExito = this.$tc('mensajes.cuestionario.bloques_guardados', cantidadEnviada, {
            count: cantidadEnviada,
          });
        }
      } catch (error) {
        this.errorEnvio = this.mensajeError(error, this.$t('mensajes.cuestionario.error_envio'));
      } finally {
        this.enviando = false;
      }
    },

    mensajeError(error, fallback) {
      if (error && error.response && error.response.status === 404) {
        return this.$t('mensajes.cuestionario.enlace_invalido');
      }
      if (error && error.response && error.response.data) {
        const data = error.response.data;
        if (data.message) return data.message;
        if (data.errors) {
          const primerError = Object.values(data.errors)[0];
          if (Array.isArray(primerError) && primerError.length) return primerError[0];
        }
      }
      return fallback;
    },

    formatearFecha(fecha) {
      if (!fecha) return '';
      const partes = String(fecha).substring(0, 10).split('-');
      if (partes.length !== 3) return fecha;
      const date = new Date(Number(partes[0]), Number(partes[1]) - 1, Number(partes[2]));
      return new Intl.DateTimeFormat(this.$i18n.locale, {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
      }).format(date);
    },
  },
};
</script>

<style scoped>
.cuestionario-page {
  min-height: 100%;
  background-color: #eeeee7;
}

.logo {
  height: 60px;
}

.cuestionario-container {
  max-width: 1320px;
}

.estado-card {
  background-color: #fbfaf1 !important;
  border-radius: 18px !important;
}

.titulo-principal {
  color: #191970;
  font-size: clamp(1.6rem, 4vw, 2.25rem);
  font-weight: 800;
  line-height: 1.2;
}

.rutas-etiqueta {
  color: #191970;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.introduccion {
  color: #555550;
  font-size: 0.94rem;
}

.secciones-paneles {
  background: transparent;
}

.seccion-panel {
  border-radius: 14px !important;
  background-color: #fbfaf1 !important;
}

.seccion-rutas {
  overflow: hidden;
}

.seccion-panel::before {
  box-shadow: 0 2px 10px rgba(25, 25, 112, 0.08) !important;
}

.seccion-header {
  min-height: 54px;
  padding: 10px 18px;
}

.seccion-titulo {
  color: #191970;
  font-size: 1.15rem;
  font-weight: 800;
  line-height: 1.25;
}

.enviar-btn {
  color: #ff9c00 !important;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: none;
}

@media (max-width: 600px) {
  .seccion-titulo {
    font-size: 1.25rem;
  }
}
</style>
